import type { ComponentChildren } from "preact";
import type { PoweredBy } from "../types";

interface ChatWindowProps {
  title: string;
  greeting?: string;
  poweredBy?: PoweredBy;
  onClose: () => void;
  children: ComponentChildren;
}

export function ChatWindow({
  title,
  greeting,
  poweredBy,
  onClose,
  children,
}: ChatWindowProps) {
  return (
    <div class="nx-window" role="dialog" aria-label={title}>
      <header class="nx-window__header">
        <div class="nx-window__title">
          <div class="nx-window__title-text">{title}</div>
          {greeting && <div class="nx-window__greeting">{greeting}</div>}
        </div>
        <button
          class="nx-window__close"
          type="button"
          onClick={onClose}
          aria-label="Close chat"
        >
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M6 6l12 12M6 18L18 6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </header>
      <div class="nx-window__body">{children}</div>
      {poweredBy && (
        <footer class="nx-window__footer">
          Powered by{" "}
          {poweredBy.url ? (
            <a
              class="nx-window__footer-link"
              href={poweredBy.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {poweredBy.name}
            </a>
          ) : (
            <span class="nx-window__footer-link">{poweredBy.name}</span>
          )}
        </footer>
      )}
    </div>
  );
}
